import React from "react";
import { Button, Dialog, Grid, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import {Warning} from "@mui/icons-material";
import { pageContentGap } from "../theme";

interface EnhancedConfirmDialogProps {
    open?: boolean;
    setOpen?: (open: boolean) => void;
    action?: (confirmed: boolean) => void;
    title?: React.ReactNode;
    message?: React.ReactNode;
    icon?: React.ReactNode;
    extensions?: React.ReactNode;
    options?: React.ReactNode;
    customColor?: string;
    type?: string;
    customConfirmText?: React.ReactNode;
    extraActions?: React.ReactNode;
    extraActionsBetween?: React.ReactNode;
    extraActionsAfter?: React.ReactNode;
    [key: string]: any;
}

function EnhancedConfirmDialog(props: EnhancedConfirmDialogProps) {
    const theme = useTheme();
    const {open, setOpen, action, title, message, icon, extensions, options, customColor, type} = props;

    let color;
    if (customColor) color = customColor;
    else if(type === "delete" || type === "caution") color = theme.palette.error.main;
    else color = theme.palette.tertiary.main;

    return (
        <Dialog open={open} onClose={() => {
            action(false);
            setOpen(false);
        }}>
                <div style={{height: "10px", width: "100%", background: color}}/>
                <Grid container style={{padding: "12px", gap: pageContentGap}}>
                <Grid item container size={12} alignItems={"center"}>
                    {icon ? icon :
                        <Grid item container style={{flex: 0.2}}>
                            <Warning style={{width: "100%", height: "55px", color: color}}/>
                        </Grid>
                    }

                    <Grid item container style={{flex: 0.75, flexDirection: "column"}}>
                        <Typography variant={"h6"} style={{fontSize: "18px"}}>{title}</Typography>
                        <Typography variant={"body1"}>{message}</Typography>
                    </Grid>
                </Grid>

                {extensions && (
                    <Grid item container size={12}>
                        {extensions}
                    </Grid>
                )}

                {options ? (
                    <>
                        {options}
                    </>
                ) : (
                    <Grid item container justifyContent={"flex-end"}
                          style={{borderTop: "1px solid #DCDCDC", paddingTop: "12px", gap: pageContentGap, width: "100%"}}>
                        <>
                            {props.extraActions}

                            <Button variant="text"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        action(false);
                                        setOpen(false);
                                    }}>
                                {props.type === "yes/no" ? "No" : "Cancel"}
                            </Button>

                            {props.extraActionsBetween}

                            <Button variant="text"
                                    color={type === "delete" ? "error" : "primary"}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        action(true);
                                        setOpen(false);
                                    }}>
                                {props.type === "yes/no"
                                    ? "Yes" :
                                    <>
                                        {props.customConfirmText ? props.customConfirmText :
                                            type === "delete"
                                                ? "Delete"
                                                : "Confirm"
                                        }
                                    </>
                                }
                            </Button>

                            {props.extraActionsAfter}
                        </>

                    </Grid>
                )}
                </Grid>
        </Dialog>
    );
}

export default EnhancedConfirmDialog;
